import React from 'react';
import { makeStyles } from 'tss-react/mui';
import MuiButton from '@mui/material/Button';

import { units } from '../theme/units';

export type ButtonProps = import('@mui/material/Button').ButtonProps;

const useStyles = makeStyles()(() => ({
  'iconSize-inherit': {
    '& > *:first-of-type': {
      fontSize: 'inherit',
    },
  },
  'iconSize-small': {
    '& > *:first-of-type': {
      fontSize: units.rem(0.5),
    },
  },
  'iconSize-medium': {
    '& > *:first-of-type': {
      fontSize: units.rem(1.25),
    },
  },
  'iconSize-large': {
    '& > *:first-of-type': {
      fontSize: units.rem(1.875),
    },
  },
}));

interface CustomProps {
  iconSize?: 'inherit' | 'small' | 'medium' | 'large' | 'default';
  rel?: string;
  target?: string;
  component?: string;
}

export type Props = CustomProps & ButtonProps;

const Button = React.forwardRef<HTMLButtonElement, Props>(
  ({ iconSize, classes, ...rest }, ref) => {
    const { classes: customClasses, cx } = useStyles();

    const newClasses = {
      ...classes,
      startIcon: cx(
        classes && classes.startIcon,
        customClasses[`iconSize-${iconSize}` as keyof typeof customClasses],
      ),
      endIcon: cx(
        classes && classes.endIcon,
        customClasses[`iconSize-${iconSize}` as keyof typeof customClasses],
      ),
    };

    return <MuiButton {...rest} ref={ref} classes={newClasses} />;
  },
);

export { Button };
